import Navbar from "../components/navbar.jsx";
import Hero from "../components/hero.jsx";
import Gallery from "../components/gallery.jsx";
import Footer from "../components/footer.jsx";

function Home()
{
    return(
        <>
        <Navbar />
        <Hero/>
        <Gallery/>
        <Footer/>
        </>
    );
}
export default Home;